
import React from 'react';
import AppTabsComponent from 'src/components/shared/appTabsComponent';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import HeaderComponent from 'src/components/header';
import Cardsview from './carddetails';
const CardDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const breadcrumbMapping = {
    transactions: "Transactions",
    authorizationRecord: "Authorization Records",
    operations: "Operations"
  };
  const currentTab = location?.pathname?.split('/')?.pop();
  const tabName = breadcrumbMapping[currentTab] || "Transactions";
  const breadCrumbList = [
    { bname: "Cards", url: "/cards" }, { bname: tabName }
  ]

  return (
    <div className='mb-5'>
      <HeaderComponent breadCrumbList={breadCrumbList} />
      <Cardsview />
      <AppTabsComponent gridId={id} serviceName={"CardsManageService.Cards"} tabPosition='top' isNoRouting={false} />
      <Outlet />
    </div>
  )
}
export default CardDetails